import React from 'react';
import { Submission } from './submission-graphql';
import UpdateSubmission from './UpdateSubmission/UpdateSubmission';
import SubmissionProvider from './Context/SubmissionProvider';

export interface SubmissionProps {
  submission: Submission;
}

const DeveloperSubmission: React.FC<SubmissionProps> = ({ submission }) => {
  return (
    <SubmissionProvider initialSubmission={submission}>
      <UpdateSubmission />
    </SubmissionProvider>
  );
};

export default DeveloperSubmission;
